import { IBaseUseQueryProps } from '../../interfaces/baseUseQueryProps';
import { IBullhornCandidate } from '../../interfaces/bullhornCandidate';
import { useQuery } from '@tanstack/react-query';
import { BullhornService } from '../../services/bullhorn';
import { useNotification } from '../../+state/useNotification';
import { AxiosErrorResponse } from '../../interfaces/errorResponse';
import { parseAxiosError } from '../../services/axios';

interface IProps extends IBaseUseQueryProps<IBullhornCandidate> {
  customerId: number;
  email: string;
}

export const GET_BULLHORN_LOOKUP_QUERY_KEY = 'get-bullhorn-lookup';

export const useBullhornLookup = ({ customerId, email, ...props }: IProps) => {
  const { openErrorToast } = useNotification();
  return useQuery({
    queryKey: [GET_BULLHORN_LOOKUP_QUERY_KEY, customerId, email],
    queryFn: () => BullhornService.lookup(customerId, email),
    onError: (err: AxiosErrorResponse) => {
      openErrorToast(parseAxiosError(err));
      props?.onError?.(err);
    },
    refetchOnWindowFocus: false,
    ...props
  });
};